const Table = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M8.05 16.25H13V11H7.75v4.95c0 .067.033.134.1.2.067.067.133.1.2.1Zm-.3-6.75h12V4.55c0-.066-.033-.133-.1-.2-.067-.066-.133-.1-.2-.1H8.05c-.067 0-.133.034-.2.1-.067.067-.1.134-.1.2V9.5Zm6.75 6.75h4.95c.067 0 .133-.033.2-.1.067-.066.1-.133.1-.2V11H14.5v5.25Zm-6.45 1.5c-.5 0-.925-.175-1.275-.525a1.736 1.736 0 0 1-.525-1.275V4.55c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h11.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v11.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H8.05Zm-3.5 3.5c-.5 0-.925-.175-1.275-.525a1.736 1.736 0 0 1-.525-1.275V6.55h1.5v12.9c0 .067.033.134.1.2.067.067.133.1.2.1h12.9v1.5H4.55Z"
        />
    </svg>
);

export default Table;
